import Methods from "@/modules/core/service/private/Methods";
import Messages from "@/modules/core/service/private/Messages";
import Core from "@/modules/core/service/Core";

const url = {
    preferences: "/api/user/preferences",
    getpreferences: "/api/user/preferences/{0}",
}

export default {
    menu (component) {
        return component.$store.getters.preferences["permanentMenu"];
    },

    customer (component) {
        if (!component.$store.getters.preferences.customer) {
            return [];
        }

        return component.$store.getters.preferences.customer.map (customer => customer.id);
    },

    get (ident) {
        return Core.method.get(url.getpreferences, ident) ;
    },

    store (component, preferences) {
        return Methods.put(url.preferences, preferences)
            .catch ((data) => {
                Messages.message.popup (component, data.id, data.parameter);
            });
    },
}